import {css, unsafeCSS} from 'lit';
import {SpAnimationFactory, SpAnimationOptions} from "./animation.interfaces";

export const scaleAnimation: SpAnimationFactory<SpScaleAnimationOptions> = (options?) => {
    options = {
        start: 0,
        factor: 1.1,
        delay: 0,
        duration: 2,
        iterationCount: 1,
        ...options
    }

    // language=CSS
    return css`
        .${ unsafeCSS(options.className ? options.className : 'scale-animation') } {
            animation: ${ unsafeCSS(options.className ? `${options.className}-frames` : 'scale-animation-frames') } linear;
            animation-duration: ${unsafeCSS(options.duration)}s;
            animation-delay: ${unsafeCSS(options.delay)}s;
            animation-iteration-count: 1;
            animation-fill-mode: forwards;
        }

        @keyframes ${ unsafeCSS(options.className ? `${options.className}-frames` : 'scale-animation-frames') } {
            0% {
                transform: scale(${options.start});
            }
            100% {
                transform: scale(${options.factor});
            }
        }`;
};

export interface SpScaleAnimationOptions extends SpAnimationOptions {
    start?: number;
    factor?: number;
}